module.exports = __webpack_public_path__ + "img/NickFury_01.7cadd7a5.png";